module.exports = require('./helpers/bundle-url').getBundleURL('4AlMw') + "map-direction-0.efbd1249.png" + "?" + Date.now();